function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import OlScaleLine from 'ol/control/ScaleLine';
import { useEffect, useRef } from 'react';
import { useOpenLayers } from '../openlayers-context';
import usePrevious from '../hooks/usePrevious';

var getScaleLineOptionsDefaults = options => {
  return _objectSpread({
    target: 'ol-controls-scale-line-target',
    className: 'ol-scale-line-override',
    minWidth: 115,
    bar: false,
    text: undefined
  }, options);
};

var ScaleUnits = {
  DEGREES: 'degrees',
  IMPERIAL: 'imperial',
  NAUTICAL: 'nautical',
  METRIC: 'metric',
  US: 'us'
};

var ScaleLine = props => {
  var {
    map
  } = useOpenLayers();
  var prevUnits = usePrevious(props.units);
  var control = useRef();
  useEffect(() => {
    if (!map) return;
    var optionsWithDefaults = getScaleLineOptionsDefaults(props);
    var scaleLine = new OlScaleLine(optionsWithDefaults);
    control.current = scaleLine;
    map.addControl(control.current);
    return () => {
      if (control.current) map.removeControl(control.current);
    };
  }, [map, props]);
  useEffect(() => {
    if (props.units && props.units !== prevUnits) {
      var _control$current;

      var isValid = Object.values(ScaleUnits).includes(props.units);
      if (isValid) (_control$current = control.current) === null || _control$current === void 0 ? void 0 : _control$current.setUnits(props.units);
    }
  }, [prevUnits, props.units]);
  return null;
};

export default ScaleLine;